module.exports = __webpack_public_path__ + "static/media/tti_portfolio@2x.cb8bbe85.png";